import { render, staticRenderFns } from "./CmgGroupOrderError.vue?vue&type=template&id=469195fa&scoped=true&lang=pug&"
import script from "./cmg-group-order-error.ts?vue&type=script&lang=ts&"
export * from "./cmg-group-order-error.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGroupOrderError.vue?vue&type=style&index=0&id=469195fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469195fa",
  null
  
)

export default component.exports